import { caisseConstants as c } from "../../../constants/caisse";

const initialState = {
  loading: false,
  releve: [],
  journal: [],
  boursiers: [],
  compte: [],
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case c.GET_RELEVE:
      return {
        ...state,
        loading: false,
        releve: payload,
      };
    case c.GET_JOURNAL:
      return {
        ...state,
        loading: false,
        journal: payload,
      };
    case c.SET_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case c.SET_BOURSIERS:
      return {
        ...state,
        loading: false,
        boursiers: payload,
      };
    case c.GET_ALL_RELEVE:
      return {
        ...state,
        loading: false,
        compte: payload,
      };
    default:
      return state;
  }
}
